// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "Header-module--wrapper--vTex2";
export var withoutBorder = "Header-module--withoutBorder--lRMAN";
export var transparentBg = "Header-module--transparentBg---sa89";
export var darkBg = "Header-module--darkBg--ivhqu";
export var isSticky = "Header-module--isSticky--xzuFA";
export var header = "Header-module--header--fFmLT";
export var logo = "Header-module--logo--+Dloa";
export var langSwitcher = "Header-module--langSwitcher--EC5JP";
export var navWrapper = "Header-module--navWrapper--4bw3S";
export var actionsWrapper = "Header-module--actionsWrapper--7NHrs";
export var userMenu = "Header-module--userMenu--3ma3b";
export var mobileMenuActions = "Header-module--mobileMenuActions--lLeAa";
export var mobileMenuTitle = "Header-module--mobileMenuTitle--PFlBc";
export var burger = "Header-module--burger--5PTXs";
export var isWhite = "Header-module--isWhite--RkrJD";